(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai-collection-directory"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ai-collection-directory').forEach((section) => {
    const input = section.querySelector('[data-collection-search]');
    const cards = Array.from(section.querySelectorAll('[data-collection-card]'));
    const count = section.querySelector('[data-result-count]');
    const empty = section.querySelector('[data-empty-message]');

    const update = () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const matches = !query || card.dataset.searchText.includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      count.textContent = `${visible} collection${visible === 1 ? '' : 's'} shown`;
      empty.hidden = visible !== 0;
    };

    input.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shaba-header"]) return;
  try {
    
let shabaMenuOpener = null;

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-shaba-open-menu]');
  const menu = document.querySelector('.shaba-menu');
  const search = document.querySelector('.shaba-mobile-search[open]');
  if (trigger && menu) {
    event.preventDefault();
    shabaMenuOpener = trigger;
    if (search) search.open = false;
    menu.open = true;
    trigger.setAttribute('aria-expanded', 'true');
    menu.querySelector('summary').focus({ preventScroll: true });
    return;
  }
  if (menu && menu.open && !menu.contains(event.target)) menu.open = false;
  if (search && !search.contains(event.target)) search.open = false;
});

document.addEventListener('toggle', (event) => {
  if (event.target.matches('.shaba-menu')) {
    document.querySelectorAll('[data-shaba-open-menu]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', String(event.target.open));
    });
    if (event.target.open) {
      const search = document.querySelector('.shaba-mobile-search[open]');
      if (search) search.open = false;
    }
  }
  if (event.target.matches('.shaba-mobile-search') && event.target.open) {
    const menu = document.querySelector('.shaba-menu[open]');
    if (menu) menu.open = false;
    event.target.querySelector('input[name="q"]').focus();
  }
}, true);

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.shaba-menu[open]');
  const search = document.querySelector('.shaba-mobile-search[open]');
  if (menu) {
    menu.open = false;
    const target = shabaMenuOpener && shabaMenuOpener.isConnected ? shabaMenuOpener : menu.querySelector('summary');
    target.focus({ preventScroll: true });
    shabaMenuOpener = null;
  }
  if (search) {
    search.open = false;
    search.querySelector('summary').focus({ preventScroll: true });
  }
});

  } catch(e) { console.error(e); }
})();
})();
